// removed by extract-text-webpack-plugin
module.exports = {"wasabi-message":"wasabi-message","success":"success","error":"error","shake":"shake","info":"info","notice":"notice","wasabi-confirm":"wasabi-confirm","message":"message","buttons":"buttons"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Unit/Message.scss
// module id = 189
// module chunks = 0